import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tcm-chat-inquiry-answer-unselect",
  "use": "icon-tcm-chat-inquiry-answer-unselect-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-tcm-chat-inquiry-answer-unselect\">\r\n  <defs>\r\n    <style>#icon-tcm-chat-inquiry-answer-unselect .a{fill:#fff;stroke:#707070;}#icon-tcm-chat-inquiry-answer-unselect .b{stroke:none;}#icon-tcm-chat-inquiry-answer-unselect .c{fill:none;}</style>\r\n  </defs>\r\n  <g class=\"a\">\r\n    <circle class=\"b\" cx=\"8\" cy=\"8\" r=\"8\" />\r\n    <circle class=\"c\" cx=\"8\" cy=\"8\" r=\"7.5\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tcm-chat-inquiry-answer-unselect.svg
// module id = He+f
// module chunks = 10